/**
 * 校验图片jpg|jpeg
 */
import COMMON from '@/axios/common/common.js'
import { forEach } from 'lodash';

export const GetVerifyImgs = {
  data() {
    return {}
  },
  methods: {
    /**
     * 校验图片jpg|jpeg
     */
    verifyImgs(dataList) {
      return new Promise((resolve, reject) => {
        let baseUrl = window.gtaAiConfig.fileBaseUrl;
        let imgList = dataList;
        let params = {
          imgUrls: []
        };
        // 处理代理字段
        if (window.location.protocol === 'https:') {
          imgList.forEach(item => {
            item.url = item.url.indexOf('service_photoDomain') !== -1 ? item.imgUrl.split('service_photoDomain')[1] : item.url;
          });
        }
        params.imgUrls = imgList.map((item) => {
          return {
            fileName: item.fileName, // 文件名称
            // fileUrl: `${this.photoBaseUrl}${item.url}`, // 文件url
            fileUrl: `${baseUrl}${item.url}`, // 文件url
          }
        });

        COMMON.verifyImgs(params).then(res => {
          if (res.isSuccess) {
            // if (res.data && res.data.correct && res.data.correct.length) {
              // let data = {
              //   datasetId: this.activeDataset,
              //   // labelId: this.activeLabel,
              //   datasetImgList: []
              // }
              // res.data.correct.forEach(i => {
              //   imgList.forEach(j => {
              //     if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
              //       data.datasetImgList.push( {
              //         imgUrl: j.url,
              //         imgName: j.fileName,
              //         imgWidth: j.width,
              //         imgHeight: j.height,
              //         imgSize: j.size,
              //       });
              //     }
              //   });
              // });
              // this.uploadImg(data); // 上传到服务器的文件转存到数据库中
            // }
            if (res.data && res.data.error_info.length) {
              res.data.error_info.forEach((i, idx) => {
                setTimeout(() => {
                  this.$message({
                    // message: `上传失败，图片名称为“${i.fileName}”只允许上传 jpg/jpeg 格式图片，此文件真实类型为${i.format}！`,
                    message: `上传失败，图片名称为“${i.fileName}”，该文件格式被后期修改过，其真实格式不为jpg/jpeg！`,
                    type: 'error',
                    duration: 2000,
                  });
                }, idx*10);
              });
              if (imgList.length === res.data.error_info.length) {
                this.fullscreenLoading.close(); // 关闭Loading
              }
            }
            resolve(res.data)
          } else {
            this.fullscreenLoading.close(); // 关闭Loading
            this.$message.error('上传失败!');
            reject(res)
          }
        }).catch((error)=>{
          this.fullscreenLoading.close(); // 关闭Loading
          this.$message.error('上传失败!');
        });
      })
    },
  },
}
